@let wifiCredentials = this.wifiCredentials();
@let wifiName = wifiCredentials?.name;
@let wifiPassword = wifiCredentials?.password;


<div class="items">
  <div class="item">
    <div class="icon">
      <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.333 26c0-8.171 0-12.257 2.539-14.795 2.538-2.539 6.624-2.539 14.795-2.539h3.25c8.17 0 12.256 0 14.795 2.539C42.25 13.743 42.25 17.829 42.25 26c0 8.17 0 12.256-2.538 14.795-2.539 2.538-6.624 2.538-14.795 2.538h-3.25c-8.171 0-12.257 0-14.795-2.538C4.334 38.256 4.334 34.17 4.334 26Z"
          stroke="currentColor"
          stroke-width="3"
        />
        <path
          d="M43.334 21.666c2.042 0 3.064 0 3.698.635.635.635.635 1.656.635 3.699s0 3.064-.635 3.699c-.634.634-1.656.634-3.698.634v-8.666Z"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="3"
        />
        <path
          d="M24.917 19.5 19.5 26h7.583l-5.416 6.5"
          stroke="currentColor"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="content">
      <div class="title">Charge Your Phone Here</div>
      <div class="description">
        This device features a wireless charging pad and universal cables on each side.
      </div>
    </div>
  </div>

  @if (wifiName) {
    <div class="item">
      <div class="icon">
        <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M4.333 18.353c11.967-12.915 31.368-12.915 43.334 0m-36.111 7.795c7.977-8.61 20.911-8.61 28.889 0m-21.667 7.796c3.989-4.305 10.456-4.305 14.444 0"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
          />
          <circle cx="26" cy="40.805" r="1.75" fill="currentColor" stroke="currentColor" stroke-width="3"/>
        </svg>
      </div>
      <div class="content">
        <div class="title">Connect To Wi-Fi</div>
        <div class="description">
          <div>Network name: <strong>{{ wifiName }}</strong></div>
          @if (wifiPassword) {
            <div>Password: <strong>{{ wifiPassword }}</strong></div>
          }
        </div>
      </div>
    </div>
  }
</div>
